/**
 * Created by Andrey Popov on 5/15/24.
 */

const NoAdsWindow = Prefab.createWindow("noads_window", "noads_window_prefab_json", {
    bundles: () => {
        const person = cleverapps.persons.choose("seller", "worker");
        const role = person && cleverapps.persons.getRole(person.role);
        return role && role.bundle ? [role.bundle] : [];
    }
});
